import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

class RadioGroup extends Component {
  render() {
    return (
      <Container>
        <Label>{this.props.label}</Label>
        <Flexer>
          {this.props.items.map((item, index) => (
            <RadioLabel key={item.value} disabled={this.props.disabled}>
              <Input
                type='radio'
                defaultChecked={this.props.default === item.value}
                value={item.value}
                name={this.props.name}
                onClick={(e) =>
                  this.props.disabled
                    ? e.preventDefault()
                    : this.props.onClick(e.target.value)
                }
              />
              {item.label}
              <Check disabled={this.props.disabled} />
            </RadioLabel>
          ))}
        </Flexer>
      </Container>
    )
  }
}

RadioGroup.defaultProps = {
  disabled: false,
}

RadioGroup.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
  onClick: PropTypes.func,
  default: PropTypes.string,
}

const Container = styled.div`
  width: 100%;
`

const Flexer = styled.div`
  display: flex;
  margin-top: 4px;
`

const Label = styled.label`
  color: #676767;
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
  text-align: left;
  width: 100%;
  display: block;
`

const Input = styled.input`
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  visibility: hidden;
  z-index: 6;

  &:checked {
    ~ div {
      background: linear-gradient(270deg, #006736 0%, #93c13e 100%);
      &::before {
        background: #ffffff;
      }
    }
  }
`

const RadioLabel = styled.label`
  display: block;
  position: relative;
  float: left;
  padding-left: 24px;
  margin-right: 24px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;

  ${({ disabled }) =>
    !disabled &&
    `
    &:hover {
      div {
        background: linear-gradient(270deg, #006736 0%, #93C13E 100%);
        &::before  {
          background: #FFFFFF;
        }
      }
    }
  `}

  &:before,
  &:after {
    content: '';
    display: table;
  }

  &:after {
    clear: both;
  }

  zoom: 1;

  ${({ disabled }) => disabled && `opacity: 0.5`};
`

const Check = styled.div`
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  border: 1px solid #9c9c9c;
  background-color: #ffffff;
  top: 3px;
  left: 3px;
  border-radius: 100%;
  z-index: 5;
  cursor: pointer;
  box-sizing: initial !important;

  ${({ disabled }) =>
    disabled &&
    `
    opacity: 0.5;`}

  &::before {
    display: block;
    position: absolute;
    content: '';
    border-radius: 100%;
    height: 8px;
    width: 8px;
    top: 3px;
    left: 3px;
    background: #ffffff;
  }
`

export default RadioGroup



// WEBPACK FOOTER //
// ./src/components/SubscriptionRadioGroup/index.js